import { Checkbox, Text, CheckboxGroupProps } from '@mantine/core';
import { useController } from 'react-hook-form';

interface Props extends CheckboxGroupProps {
	className?: string;
	name: string;
}

export const CheckboxGroupV2 = ({ className, name, children, ...props }: Props) => {
	const {
		field,
		fieldState: { error },
	} = useController({ name });

	return (
		<Checkbox.Group
			error={
				error?.message ? (
					<Text c="red.6" sx={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>
						{error?.message?.toString()}
					</Text>
				) : null
			}
			value={field.value}
			onChange={field.onChange}
			className={className}
			{...props}
		>
			{children}
		</Checkbox.Group>
	);
};
